import { render, staticRenderFns } from "./TestLocations.vue?vue&type=template&id=7cc4ae83"
import script from "./TestLocations.vue?vue&type=script&lang=js"
export * from "./TestLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports